import { render, staticRenderFns } from "./show_over.vue?vue&type=template&id=25df9124&scoped=true&"
import script from "./show_over.vue?vue&type=script&lang=js&"
export * from "./show_over.vue?vue&type=script&lang=js&"
import style0 from "./show_over.vue?vue&type=style&index=0&id=25df9124&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25df9124",
  null
  
)

export default component.exports